module.exports = __webpack_public_path__ + "img/home_header_xs.5d443889.png";